import { Badge } from '@shopify/polaris';

export function getOrderStatus(status: any) {
  switch (status) {
    case 9:
      return <Badge tone={'read-only'}>ĐƠN ĐÃ HỦY</Badge>;
    case 0:
      return <Badge tone={'read-only'}>ĐƠN NHÁP</Badge>;
    case 1:
      return <Badge tone={'success-strong'}>ĐÃ XẾP CHUYẾN</Badge>;
    case 2:
      return <Badge tone={'success-strong'}>TRONG CHUYẾN</Badge>;
    case 3:
      return <Badge tone={'success-strong'}>HOÀN THÀNH</Badge>;
  }
}

